import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Grid,
  Button,
  MenuItem,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  OutlinedInput,
} from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import { FormLabel } from "react-bootstrap";
import ApiClient from "utils/ApiClient";
import styled from "styled-components";

export const ShareAccountModal = ({
  accountModalData,
  setAccountModalData,
  store,
  closeModal,
  showAlert,
}) => {
  const [value, setValue] = useState(accountModalData.accountHolder.can_view);
  const [personName, setPersonName] = useState([]);

  const inputFields = [
    { value: "3", label: "All domain members" },
    { value: "2", label: "Only few roles of this sheet" },
    { value: "1", label: "Only me" },
    { value: "0", label: "All shared members of this sheet" },
  ];

  const submit = async () => {
    const body = {};
    if(value == '2' && personName.length == 0){
      showAlert("Please select atleast one role", false);
      return;
    }
    body.can_view = value ? value : accountModalData.accountHolder.can_view;
    body.can_view_roles =
      value == "2"
        ? personName.length
          ? personName.join(",")
          : accountModalData.accountHolder.can_view_roles
        : "";
    body.for_entire_company = value
      ? value == "3"
        ? 1
        : 0
      : accountModalData.accountHolder.can_view == "3"
      ? 1
      : 0;
    body.list_id = store.listId;
    body.account_id = accountModalData.accountHolder.id;
    body.is_web = 1;
    const data = await ApiClient.MailMerge.setAccountPermissions(body);
    if (data.success) {
      setAccountModalData({ ...accountModalData, showShareModal: false });
      closeModal();
      showAlert("Success", true);
    } else {
      showAlert("Failed", false);
    }
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a the stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  return (
    <Modal
      open={accountModalData.showShareModal}
      onClose={() => setAccountModalData({ ...accountModalData, showShareModal: false })}
    >
      <StyledBox>
        <StyledGrid container alignItems="center">
          <Grid item>
            <Typography variant="p">
              Share Account {"<"}
              {accountModalData.accountHolder.email}
              {">"}
            </Typography>
          </Grid>
          <Grid item style={{ flex: "1" }}></Grid>
          <Grid item>
            <Close
              onClick={() => setAccountModalData({ ...accountModalData, showShareModal: false })}
              style={{ color: "white" }}
            />
          </Grid>
        </StyledGrid>
        <Grid container style={{ margin: "10px" }}>
          <FormControl component="fieldset">
            <FormLabel component="legend" style={{ fontSize: "1rem" }}>
              Who can use this email account to send mails ?
            </FormLabel>
            <RadioGroup aria-label="share" name="radio-buttons-group" style={{ margin: "10px" }}>
              {inputFields.map((item, index) => {
                return (
                  <FormControlLabel
                    key={item.label}
                    checked={
                      value
                        ? value == item.value
                        : accountModalData.accountHolder.can_view == item.value
                    }
                    value={item.value}
                    control={<Radio size="small" />}
                    label={item.label}
                    onClick={(e) => {
                      setValue(e.target.value);
                    }}
                  />
                );
              })}
              {value == "2" && (
                <Grid container style={{ margin: "10px" }}>
                  <Grid item style={{ margin: "5px 10px" }}>
                    <Typography>Roles:</Typography>
                  </Grid>
                  <Grid item style={{ flex: "1" }}>
                    <Select
                      disabled={
                        value ? value !== "2" : accountModalData.accountHolder.can_view !== "2"
                      }
                      fullWidth
                      multiple
                      value={
                        personName.length
                          ? personName
                          : accountModalData.accountHolder.can_view_roles.length
                          ? accountModalData.accountHolder.can_view_roles.split(",")
                          : []
                      }
                      onChange={handleChange}
                      input={<OutlinedInput />}
                    >
                      <MenuItem value="33">Admin Users</MenuItem>
                      <MenuItem value="34">Standard Users</MenuItem>
                    </Select>
                  </Grid>
                </Grid>
              )}
            </RadioGroup>
          </FormControl>
          <Grid container>
            <Button variant="contained" color="primary" onClick={submit}>
              Done
            </Button>
          </Grid>
        </Grid>
      </StyledBox>
    </Modal>
  );
};

export default ShareAccountModal;

const StyledBox = styled(Box)`
  && {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-width: 50%;
    background-color: white;
    border-radius: 5px;
    box-shadow: 0.5px 1px 25px 0.5px rgba(0, 0, 0, 0.3);
  }
`;
const StyledGrid = styled(Grid)`
  && {
    padding: 10px 10px 10px 10px;
    background-color: #404040;
    color: white;
  }
`;